module.exports = __webpack_public_path__ + "img/HC2011-175.2e78209b.jpg";